class SpecificationTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.spec-tabs__tab'));
    this.panels = Array.from(this.querySelectorAll('.spec-tabs__panel'));
    this.nav = this.querySelector('.spec-tabs__nav');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab));
    });
  }

  activateTab(activeTab) {
    const targetIndex = activeTab.getAttribute('data-tab-index');

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('spec-tabs__tab--active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });

    this.panels.forEach((panel) => {
      const isActive = panel.getAttribute('data-panel-index') === targetIndex;
      panel.classList.toggle('spec-tabs__panel--hidden', !isActive);
    });

    this.scrollTabIntoView(activeTab);
  }

  scrollTabIntoView(tab) {
    if (!this.nav) return;

    const OFFSET = 48;
    const navLeft = this.nav.getBoundingClientRect().left;
    const tabLeft = tab.getBoundingClientRect().left;
    const scrollAmount = this.nav.scrollLeft + (tabLeft - navLeft) - OFFSET;

    this.nav.scrollTo({ left: scrollAmount, behavior: 'smooth' });
  }
}

customElements.define('specification-tabs', SpecificationTabs);
